module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921111151_T.1b25968c.jpg";